import { observable, action } from 'mobx'

class Action {

  @observable
  data = {
    test: 'root'
  }
}

export default Action


// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-main/model.js